<template>
  <div class="privacy-container">
    <div class="back-nav">
      <button @click="goBack" class="back-link">← Back to Home</button>
    </div>
    <div class="content">
      <h1 class="title">Privacy policy</h1>
      
      <p>
        Please read this Privacy Policy carefully as it sets out important information relating to how we
        handle your personal information. Remove BG - Background Eraser app is an Ad Supported app. This SERVICE is at no cost and is intended for use as is.
      </p>

      <p>
        This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.
      </p>

      <p>
        If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.
      </p>

      <p>
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Remove BG - Background Eraser unless otherwise defined in this Privacy Policy.
      </p>

      <h2>Information Collection and Use</h2>

      <p>
        For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information. The information that I request will be retained on your device and is not collected by me in any way.
      </p>

      <p>
        The app does use third party services that may collect information used to identify you.
      </p>

      <p>
        Link to privacy policy of third party service providers used by the app
      </p>

      <ul>
        <li>Google Play Services</li>
        <li>AdMob</li>
        <li>Firebase Analytics</li>
      </ul>

      <h2>Log Data</h2>

      <p>
        I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol ("IP") address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.
      </p>

      <h2>Cookies</h2>

      <p>
        Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
      </p>

      <p>
        This Service does not use these "cookies" explicitly. However, the app may use third party code and libraries that use "cookies" to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
      </p>

      <h2>Service Providers</h2>

      <p>
        I may employ third-party companies and individuals due to the following reasons:
      </p>

      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services;</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>

      <p>
        I want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
      </p>

      <h2>Payments</h2>

      <p>
        Certain Apps may include additional features and services that are subject to payment, the payment can be in terms of an ongoing subscription plans ("Subscription") or one-time payment.
      </p>

      <p>
        The Subscription includes different prices or payment terms according to the duration of the applicable Subscription or the type of device you own, all as specified in our pricing page, available here. Our Subscriptions are pre-paid and you will be charged once at the beginning of each subscription period. We may offer distinctive features or services in Subscription, add new features or change or cancel any existing features or functionalities at our sole discretion. We further reserve the right to change the Subscription fees at our sole discretion. If you are a paid User at the time of such change, the new rate will be affected upon your next subscription period; otherwise, you may choose to cancel your Subscription, in which case you will be refunded on a pro-rata basis.
      </p>

      <p>
        The Company may offer, at its sole discretion, a free trial for each of the Subscriptions ("Free Trial"). When you sign up for a Free Trial, you acknowledge and agree that unless you actively cancel your Subscription by the end of the Free Trial, you will be automatically billed subject to the then-current terms of the applicable Subscription.
      </p>

      <p>
        Once you purchase a Subscription, your subscription will renew automatically and your selected payment method will be charged the applicable fees, unless you actively cancel your Subscription using your App Store or Google Play account, as applicable, in which case you will lose access to the Subscription at the end of the current billing period, and you will not receive a refund for the current billing period, regardless of the cancellation date.
      </p>

      <p>
        In order to process the Subscription fees, use in-app payment processors such as Google Pay on your Android App (Google's terms are available here, and the privacy notice is available here). Therefore, your transactions are subject to the then-current payment processors' terms of use and privacy policies. You agree to review and be bound by such terms and privacy policies in the event you make any payment with respect to Company's Services. The Company will not be liable for any act and/or omission made by such payment processors. The Company will notify you in accordance with the notification terms under these EULA in the event different or additional payment processors are used by the Company to process payments for any Company's Services.
      </p>

      <p>
        Cancellation terms and disputes will be subject to such payment processors' terms.
      </p>

      <p>
        Refunds. The Company may issue full or partial refunds for its paid Services depending on the Refunds' reason. The Company Refund policy enable User to issue a Refund Request ("Refund Request") upon to thirty (30) days of purchase. In case the Company approved a Refund Request, the User will get a cancellation email from Google Pay, as applicable, which indicating that their subscription or in-app purchase has been canceled.
      </p>

      <h2>User Consent for Data Processing Related to Refund Requests</h2>

      <p>
        In accordance with the App Store's refund policy, when a user initiates a refund request, our server will receive a notification (CONSUMPTION_REQUEST) from Apple. In such cases, we will provide Apple with data related to the user's subscription to assist Apple in making a decision regarding the refund request.
      </p>

      <p>
        Please note that the data provided is strictly limited to subscription-related consumption information and does not include any personal or sensitive data. We are committed to complying with Apple's requirements and ensuring that all data processing activities fully adhere to privacy protection laws and regulations.
      </p>

      <p>
        By using this app, you consent to the transmission of your subscription consumption data to Apple, as required for processing refund requests, in compliance with the App Store's refund policies.
      </p>

      <h2>Security</h2>

      <p>
        I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.
      </p>

      <h2>Links to Other Sites</h2>

      <p>
        This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
      </p>

      <h2>Children's Privacy</h2>

      <p>
        These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
      </p>

      <h2>Changes to This Privacy Policy</h2>

      <p>
        I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
      </p>

      <h2>Contact Us</h2>

      <p>
        If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at yikenyonggang@gmail.com
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goBack = () => {
  console.log('Going back to Remove BG home')
  router.push('/remove_bg')
}
</script>

<style scoped>
.privacy-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 20px 40px;
  background-color: #ffffff;
  min-height: 100vh;
}

.back-nav {
  margin-bottom: 20px;
}

.back-link {
  display: inline-block;
  color: #007bff;
  background: none;
  border: 1px solid #007bff;
  padding: 8px 15px;
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 14px;
  cursor: pointer;
}

.back-link:hover {
  background-color: #007bff;
  color: white;
}

.content {
  line-height: 1.8;
  color: #333;
}

.title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #222;
}

h2 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 15px;
  color: #222;
}

p {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
}

ul {
  margin: 15px 0;
  padding-left: 30px;
}

li {
  margin-bottom: 8px;
  font-size: 14px;
}

a {
  color: blue;
  text-decoration: underline;
}

a:visited {
  color: purple;
}

/* 移动端优化 */
@media screen and (max-width: 768px) {
  .privacy-container {
    padding: 15px 15px 30px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    text-align: left;
  }

  ul {
    padding-left: 20px;
  }

  li {
    font-size: 14px;
  }
}
</style>

